module.exports = __webpack_public_path__ + "img/Millionaire-2.3ba127fe.gif";